module.exports = __webpack_public_path__ + "img/download.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/download.png
// module id = 376
// module chunks = 0